(() => {
  function setup(scope=document) {
    scope.querySelectorAll('[data-bundle-builder]').forEach(root => {
      if(root.dataset.ready) return;
      root.dataset.ready='true';
      const strings=JSON.parse(root.querySelector('[data-bundle-strings]').textContent);
      const slots=root.querySelector('[data-bundle-slots]'),submit=root.querySelector('[data-bundle-submit]'),status=root.querySelector('[data-bundle-status]');
      const products=[...root.querySelectorAll('[data-bundle-product]')];
      const selected=[];
      const money=value=>new Intl.NumberFormat(document.documentElement.lang||'tr',{style:'currency',currency:root.dataset.currency||'TRY'}).format(value/100);
      const node=(tag,text,className)=>{const el=document.createElement(tag);if(text!==undefined)el.textContent=text;if(className)el.className=className;return el;};
      let busy=false;
      const draw=()=>{
        slots.replaceChildren();
        const cheapest=selected.length===3?Math.min(...selected.map(p=>p.price)):0;
        let giftShown=false;
        for(let i=0;i<3;i++){
          const item=selected[i],li=node('li',undefined,'sv-bundle__slot');
          if(item){
            if(item.image){const img=node('img');img.src=item.image;img.alt='';img.width=44;img.height=56;li.append(img);}
            const text=node('p',item.title+(item.variant==='Default Title'?'':' · '+item.variant));
            const gift=selected.length===3&&!giftShown&&item.price===cheapest;
            if(gift)giftShown=true;
            text.append(node('small',gift?strings.gift:money(item.price)));
            const remove=node('button','×');remove.type='button';remove.setAttribute('aria-label',strings.remove+' '+item.title);
            remove.addEventListener('click',()=>{selected.splice(i,1);draw();root.querySelector('[data-bundle-add]:not(:disabled)')?.focus();});
            li.append(text,remove);
          }else li.append(node('span',String(i+1)),node('p',strings.empty));
          slots.append(li);
        }
        const subtotal=selected.reduce((sum,p)=>sum+p.price,0);
        root.querySelector('[data-bundle-count]').textContent=selected.length+' / 3';
        root.querySelector('[data-bundle-subtotal]').textContent=money(subtotal);
        root.querySelector('[data-bundle-saving]').textContent=cheapest?'−'+money(cheapest):'—';
        root.querySelector('[data-bundle-total]').textContent=selected.length===3?money(subtotal-cheapest):'—';
        submit.disabled=selected.length!==3||busy;
        status.textContent=selected.length===3?strings.ready:strings.selected.replace('[count]',String(3-selected.length));
        products.forEach(card=>{const option=card.querySelector('select').selectedOptions[0];card.querySelector('[data-bundle-add]').disabled=busy||selected.length===3||option.dataset.available!=='true';});
      };
      products.forEach(card=>{
        const select=card.querySelector('select');
        select.addEventListener('change',()=>{card.querySelector('[data-bundle-price]').textContent=money(Number(select.selectedOptions[0].dataset.price));draw();});
        card.querySelector('[data-bundle-add]').addEventListener('click',()=>{
          if(selected.length===3||busy)return;
          const option=select.selectedOptions[0];if(option.dataset.available!=='true')return;
          const info=JSON.parse(card.querySelector('[data-bundle-info]').textContent);
          selected.push({...info,id:option.value,variant:option.textContent.split(' — ')[0],price:Number(option.dataset.price)});draw();
          if(selected.length===3&&matchMedia('(max-width:749px)').matches)root.querySelector('.sv-bundle__selection').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
        });
      });
      root.querySelector('[data-bundle-search]').addEventListener('input',event=>{
        const query=event.target.value.toLocaleLowerCase('tr').trim();let visible=0;
        products.forEach(card=>{card.hidden=!card.dataset.title.toLocaleLowerCase('tr').includes(query);if(!card.hidden)visible++;});
        root.querySelector('[data-bundle-empty]').hidden=visible>0;
      });
      submit.addEventListener('click',async()=>{
        if(busy||selected.length!==3)return;
        busy=true;draw();status.textContent=strings.adding;root.setAttribute('aria-busy','true');
        const quantities=new Map();selected.forEach(item=>quantities.set(item.id,(quantities.get(item.id)||0)+1));
        try{
          const response=await fetch(root.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...quantities].map(([id,quantity])=>({id,quantity}))})});
          const result=await response.json();if(!response.ok)throw new Error(result.description||result.message||strings.error);
          window.location.assign(root.dataset.cartUrl);
        }catch(error){busy=false;draw();status.textContent=error.message||strings.error;root.removeAttribute('aria-busy');}
      });
      draw();
      root.addEventListener('storm:bundle-preset',event=>{
        const handles=event.detail?.handles;if(!Array.isArray(handles)||handles.length!==3||busy)return;
        const cards=handles.map(handle=>products.find(card=>card.dataset.handle===handle&&card.querySelector('select').selectedOptions[0]?.dataset.available==='true'));
        if(cards.some(card=>!card))return;
        selected.splice(0,selected.length);
        cards.forEach(card=>{const option=card.querySelector('select').selectedOptions[0],info=JSON.parse(card.querySelector('[data-bundle-info]').textContent);selected.push({...info,id:option.value,variant:option.textContent.split(' — ')[0],price:Number(option.dataset.price)});});
        draw();root.querySelector('.sv-bundle__selection').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});submit.focus({preventScroll:true});
      });
      const params=new URLSearchParams(location.search);
      const initial=products.find(card=>card.dataset.handle===params.get('product'));
      if(initial){
        const select=initial.querySelector('select');
        if([...select.options].some(option=>option.value===params.get('variant')&&!option.disabled))select.value=params.get('variant');
        const quantity=params.get('quantity')==='3'?3:1;
        for(let i=0;i<quantity;i++)initial.querySelector('[data-bundle-add]').click();
        if(quantity===1){
          const list=root.querySelector('.sv-bundle__products');
          list.prepend(initial);
          fetch(root.dataset.root+'recommendations/products.json?product_id='+initial.dataset.productId+'&limit=8&intent=related',{headers:{Accept:'application/json'}}).then(response=>response.ok?response.json():null).then(result=>{
            const recommended=(result?.products||[]).map(product=>products.find(card=>card.dataset.handle===product.handle)).filter(Boolean).filter(card=>card!==initial);
            if(recommended.length)list.prepend(...recommended);
          }).catch(()=>{});
        }
      }
    });
  }
  setup();document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
